import moment from "moment";

const DATE_FORMAT = "DD/MM/YYYY";
const DATE_TIME_FORMAT = `${DATE_FORMAT} HH:mm`;
export const formatDate = (date: Date | string) =>
  date ? moment(date).format(DATE_FORMAT) : "";
export const formatDateTime = (date: Date | string) =>
  date ? moment(date).format(DATE_TIME_FORMAT) : "";
